import ContactPage from "../components/ContactPage";
import Head from "next/head";
import Metatags from "../components/Metatags";
import PropTypes from "prop-types";
import { getContactPage } from "../core/api/contactPage";
import { getFooter } from "../core/api/core";
import { getMenu } from "../core/api/menu";

export default function Contact({ data, menuData, globalData }) {
  const { title } = data.wagtail.contactPage;

  return (
    <>
      <Head>
        <title>Reskinned | {title}</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.contactPage.metaTitle}
        metaDescription={data.wagtail.contactPage.metaDescription}
      />
      <ContactPage
        pageData={data.wagtail.contactPage}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

Contact.propTypes = {
  menuData: PropTypes.array.isRequired,
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
};

export async function getStaticProps() {
  const { data } = await getContactPage();
  const menuData = await getMenu();
  const globalData = await getFooter();

  return {
    props: {
      data,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}
